import { createdATFilter } from 'modules/common/constants';

export const testimonyFilters = [createdATFilter];
